import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{staticClass:"tema-combo",attrs:{"id":"temas-select","item-text":"nome","items":_vm.temas,"label":"Temas","return-object":true,"placeholder":"Temas","disabled":_vm.disabled,"multiple":""},on:{"change":function($event){return _vm.$emit('onChange', _vm.chooseTemas)}},model:{value:(_vm.chooseTemas),callback:function ($$v) {_vm.chooseTemas=$$v},expression:"chooseTemas"}},[_c('template',{slot:"no-data"},[_vm._v(" Nenhum Tema ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }